import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientWalletApi } from '../api/patientwallet.api';
import { switchMap, map } from 'rxjs/operators';

import { PatientWalletData, PatientWallet } from '../../../interfaces/patient-services/patient-wallet';

@Injectable()
export class PatientWalletService extends PatientWalletData {

    constructor(private api: PatientWalletApi) {
      super();
    }
  
  
    list(url: string): Observable<any[]> {
      return this.api.list(url);
    }
  searchList(url: string,data:any): Observable<any> {
      return this.api.searchList(url,data);
    }
  
    getById(url:string): Observable<PatientWallet>{
        return this.api.getById(url);
    }
  
    create(url: string, data:any): Observable<any> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:any): Observable<any> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  